import { useEffect, useRef } from 'react';

export const useTimeout = () => {
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => {
        const timeout = timeoutRef.current;
        return () => {
            if (timeout) clearInterval(timeout);
        };
    }, []);

    return timeoutRef;
};
